module.exports = __webpack_public_path__ + "c96d8fc2c5dd21f90c84da3a2c49e1a1.png";